export default __webpack_public_path__ + "static/media/SENAIT_FR_SEQ08.80bab677.mp3";